import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import {getArrayRandValue, getRandomFloat, getRandomInt} from "../../framework/src/helpers";
import {
    madnes_set_alpha,
    madnes_set_pos_x,
    madnes_set_pos_y
} from "../../framework/src/engine/madnes/madnes_object";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolPestle(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {Array<MadnesObject>} */
    this._sparkles = [];

    this._spraklesDiameter = 110;
    this._sparklesOffsetY = -35;

    /** @type {MadnesObject|null} */
    this._winShineObject;
    /** @type {Function|null} */
    this._winAnimResolver;

    this._sparklesPositions = [
        [61, 91], [76, 74], [93, 72], [109, 56], [129, 58], [149, 67],
        [116, 76], [88, 93], [114, 93], [47, 56], [113, 117], [87, 48],
        [124, 41], [164, 38], [155, 91], [94, 25], [172, 48], [145, 30]
    ];
};

SymbolPestle.prototype = Object.create(AbstractSymbol.prototype);
SymbolPestle.prototype.constructor = SymbolPestle;

SymbolPestle.shineColor = 0x7adeff;

/**
 * @returns {number}
 */
SymbolPestle.prototype.getShineColor = function() {
    return SymbolPestle.shineColor;
};

SymbolPestle.prototype.clear = function() {
    this._clearParentSprite();
    //this.parentSprite.setTexture(null);

    this.shineSymbol = null;
    this.destroyShineAnim();

    this._winShineObject = null;
    this._winAnimResolver = null;

    this._sparkles = [];
    this._stopSparkles();
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles[i].destroy();
    }

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolPestle.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);

    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolPestle.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

SymbolPestle.prototype._createSparkles = function() {
    for(var i = 0; i < 8; i++) {
        var scale = getRandomFloat(0.6, 1);
        //var rand = MI.getCircleRandInnerPoint(0, 0, this._spraklesDiameter);

        this._sparkles[i] = this.createImage(0, 0, "symbols_atlas").setFrameName("spark_small_turquoise");
        this._sparkles[i].setAlpha(0);
        this._sparkles[i].setScale(scale, scale);
        this._sparkles[i].setAnchor(.5, .5);
        this._sparkles[i]._stopped = true;
    }
};

SymbolPestle.prototype.createStandAnim = function() {

    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName + "_shine").setBlend("ADD");//.setScale(1.5, 1.5);
    this.createShineAnim();

    this._createSparkles();
};

SymbolPestle.prototype.playStandAnim = function() {
    this._playSparkles();
};


SymbolPestle.prototype.stopStandAnim = function() {
    this._stopSparkles();
};

SymbolPestle.prototype.fadeOutStandAnim = function() {
    var _self = this;

    var obj = { 'alpha' : 1 };

    MI.addTween().to(obj, { 'alpha': 0 }, {
        'duration': 200,
        'update': function() {
            for(var i = 0; i < _self._sparkles.length; i++) {
                _self._sparkles[i].setAlpha(_self._sparkles[i].getAlpha() * obj['alpha']);
            }
        },
        'callback': function() {
            _self._stopSparkles();
            for(var i = 0; i < _self._sparkles.length; i++) {
                _self._sparkles[i].destroy();
            }
            _self._sparkles.length = 0;
        }
    });
};

SymbolPestle.prototype.fadeInStandAnim = function() {
    this._createSparkles();
    this._playSparkles();
};

SymbolPestle.prototype._playSparkles = function() {
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles[i]._stopped = false;
        this._sparkleAnim(this._sparkles[i]);
    }
};

SymbolPestle.prototype._stopSparkles = function() {
    for(var i = 0; i < this._sparkles.length; i++) {
        this._sparkles._stopped = true;

        if(this._sparkles[i]._sparkleTweenMove) {
            this._sparkles[i]._sparkleTweenMove.stop();
        }
        /*if(this._sparkles[i]._sparkleTweenAlpha) {
            this._sparkles[i]._sparkleTweenAlpha.stop();
        }*/
    }
};

SymbolPestle.prototype._sparkleAnim = function(sparkle) {

    if(!AbstractSymbol.spriteExists(sparkle) || sparkle._stopped) return;

    // /** @type {SymbolPestle} */
    // var _self = this;

    var pos = AbstractSymbol.getRealPosition(getArrayRandValue(this._sparklesPositions));
    var rand = MI.getCircleRandInnerPoint(0, 0, 25);

    var obj = { 'move': 0, 'alpha': 0 };

    // console.log(sparkle);

    madnes_set_pos_x(sparkle.name, pos[0] + rand['x'], true);
    madnes_set_pos_y(sparkle.name, pos[1] + rand['y'], true);

    sparkle._sparkleTweenMove = MI.addTween().to(obj, { 'move': -getRandomInt(5, 20), 'alpha': 3 }, {
        //'delay': getRandomInt(0, 1000),
        'duration': getRandomInt(800, 2500),
        'update': () => {

            if(!AbstractSymbol.spriteExists(sparkle)) return;

            madnes_set_pos_y(sparkle.name, pos[1] + obj['move'], true);

            if(obj['alpha'] <= 1) {
                madnes_set_alpha(sparkle.name, obj['alpha']);
            }

            if(obj['alpha'] > 1 && obj['alpha'] < 2) {
                madnes_set_alpha(sparkle.name, 1);
            }

            if(obj['alpha'] >= 2) {
                madnes_set_alpha(sparkle.name, 3 - obj.alpha);
            }
        },
        'callback': () => this._sparkleAnim(sparkle)
    });

    /*var delay = getRandomInt(0, 1000);
    var y = sparkle.getPosY();

    sparkle._sparkleTweenMove = MI.addTween().to(sparkle, { 'y': y -14 }, {
        'duration': 1200,
        'delay': delay,
        'onStart': function() {
            sparkle.setAlpha(1);
        },
        'callback': function() {
            var rand = MI.getCircleRandInnerPoint(0, 0, this._spraklesDiameter);
            sparkle.setPos(rand['x'], rand['y'] + this._sparklesOffsetY, true);
            this._sparkleAnim(sparkle);
        }.bind(this)
    });

    sparkle._sparkleTweenAlpha = MI.addTween().to(sparkle, { 'alpha': 0 }, {
        'duration': 300,
        'delay': delay + 800
    });*/
};

/**
 * @returns {SymbolPestle}
 */
SymbolPestle.prototype.createWinSymbol = function() {

    this.createSymbol();
    this._winShineObject = this.createImage(0, 0, "symbol_Pestle_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineObject.createAnims();

    this._winShineObject.anims.add("shine", MI.generateFrameNames("symbol_Pestle_", 0, 19, "", 5));

    this._winShineObject.anims.addOnComplete(function() {
        this._winAnimResolver && this._winAnimResolver();
    }.bind(this));

    return this;
};

/**
 * @returns {Promise}
 */
SymbolPestle.prototype.playWinAnim = function() {
    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("shine");

    }.bind(this));
};

SymbolPestle.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};

SymbolPestle.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};